import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { Message, Input, Form, Schema, Animation, Button } from 'rsuite';



function withParams(Component) {
  return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}



export class Page_list extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pages: null,
    };

  }


  // ---------------- componentDidMount--------------------------

  componentDidMount() {

    Send('page/pages/list', "", true).then((res) => {

      this.setState({
        pages: res.data.pages,
      });


    }).catch((err) => { });

  }



  // ---------------- componentWillUnmount--------------------------

  componentWillUnmount() {

    H1.NavShow();
  }








  render() {

    this.state.diet && H1.page_name(this.state.diet.name);

    return !this.state.pages ? null : (


      <div className="h-100 mt-4">




        <div className='c-row'>


          <div className="text-center mb-2 py-2 position-relative">

            {/* <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.props.navigation(-1)}></span> */}
            <span className='fs-6'> آشنایی بیشتر </span>


          </div>


        </div>



        <div className="c-row mt-4">

        
        {this.state.pages.map((item, index) => [


          <NavLink exact="true" to={'/page/' + item.slug} key={index}>
             <img className='cover br-16 mb-3' src={item.cover ?? '/img/not.png'} width="100%" height="auto" />
          </NavLink>


        ])}




        </div>




      </div>

    )

  }
}

export default withParams(Page_list);
